import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-0.5 md:mt-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "md:mt-0.5 text-xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" })
], -1)


import { useGameStore } from "@/Store/useGameStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerItem',
  props: {
    name: {}
  },
  setup(__props: any) {

const gameStore = useGameStore();

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(gameStore).removePlayer(props.name))),
    class: "flex flex-row text-white md:text-lg text-md px-2 py-1 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-700 cursor-pointer"
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(props.name), 1),
    _hoisted_2
  ]))
}
}

})